import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLectureContent as getLectureContentApi } from "@/services/apiLectureContent";

export function useLectureContent({
  courseId,
  lectureId,
  apiOperations: { filter, sortBy, include, includeFields, page, perPage = 1 },
}) {
  const queryClient = useQueryClient();

  const {
    isPending,
    data: lectureContent,
    error,
  } = useQuery({
    queryKey: [
      "lectureContent",
      courseId,
      lectureId,
      page,
      perPage,
      filter,
      include,
      includeFields,
      sortBy,
    ],
    queryFn: () =>
      getLectureContentApi({
        courseId,
        lectureId,
        apiOperations: { filter, sortBy, include, includeFields, page, perPage },
      }),
    retry: false,
    enabled: !!courseId && !!lectureId,
  });

  const totalPages = Math.ceil(lectureContent?.meta.total / lectureContent?.meta.per_page);

  //PRE-FETCHING
  if (!isPending && page < totalPages) {
    queryClient.prefetchQuery({
      queryKey: [
        "lectureContent",
        courseId,
        lectureId,
        page,
        perPage,
        filter,
        include,
        includeFields,
        sortBy,
      ],
      queryFn: () =>
        getLectureContentApi({
          courseId,
          lectureId,
          apiOperations: { filter, sortBy, include, includeFields, page: page++, perPage },
        }),
    });
  }

  if (!isPending && page > 1) {
    queryClient.prefetchQuery({
      queryKey: [
        "lectureContent",
        courseId,
        lectureId,
        page,
        perPage,
        filter,
        include,
        includeFields,
        sortBy,
      ],
      queryFn: () =>
        getLectureContentApi({
          courseId,
          lectureId,
          apiOperations: { filter, sortBy, include, page: page--, includeFields, perPage },
        }),
    });
  }

  return { isPending, lectureContent, error };
}
